var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 70 70",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3797 48.8537C55.913 48.8537 55.4755 48.7078 55.0672 48.4162C54.1047 47.687 53.9005 46.3162 54.6297 45.3537C59.2089 39.2578 59.2089 30.7412 54.6297 24.6453C53.9005 23.6828 54.1047 22.312 55.0672 21.5828C56.0297 20.8537 57.4005 21.0578 58.1297 22.0203C63.8755 29.662 63.8755 40.337 58.1297 47.9787C57.7214 48.562 57.0505 48.8537 56.3797 48.8537Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7707 11.025C41.5041 9.21667 37.3332 9.68334 33.0749 12.3375L24.5582 17.675C23.9749 18.025 23.3041 18.2292 22.6332 18.2292H19.9207H18.4624C11.4041 18.2292 7.5249 22.1083 7.5249 29.1667V40.8333C7.5249 47.8917 11.4041 51.7708 18.4624 51.7708H19.9207H22.6332C23.3041 51.7708 23.9749 51.975 24.5582 52.325L33.0749 57.6625C35.6416 59.2667 38.1499 60.0542 40.4832 60.0542C41.9999 60.0542 43.4582 59.7042 44.7707 58.975C48.0082 57.1667 49.8166 53.4042 49.8166 48.3875V21.6125C49.8166 16.5958 48.0082 12.8333 44.7707 11.025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume-mute.f4fb98e15b349c3194d3abe3525cd44f.svg";
export { ForwardRef as ReactComponent };